
import './MembersSearch.module.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { TableList } from "../../../components";
import common from '../../../common';
import axios from 'axios';
import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function MembersSearch() {
    
    const member_idx = useSelector((state) => state.user.loginInfo || null);

    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [user, setUser] = useState([]);


    const [UserSearchformValues, setUserSearchformValues] = useState({
        k_code: '',
        k_university: '',
        k_major: '',
        k_number: '',
        k_name: '',
        k_job: '',
    });
    
    const userData = async () => {

        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_member/in/member_get_table`, UserSearchformValues, {
                withCredentials: true
            });
            if (response.data.result === 't') {
                const data = response.data.data;
                setUser(data);
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
            pAlert('데이터 전송에 실패했습니다. 다시 시도해주세요.');
        } finally {
            pLoadingOff();
        }
    };

    let joinMonth = 'joinMonth';
    if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
        joinMonth = '';
    }

    const columns = useMemo(() => [
        // { title: '', dataIndex: 'user_thumbnail', className: 'p_td_w_10' },
        { title: '이름', dataIndex: 'user_name', className: '' },
        { title: '학교/학과', dataIndex: 'user_university', className: ' text_start' },
        { title: '직장', dataIndex: 'job', className: ' text_start' },
        { title: '입회시기', dataIndex: joinMonth, className: '' },
    ], []);

    const pageSize = 10;
    // const categoryOptions = useMemo(() => ['전체', '이름', '소속학교', '학과', '전화번호', '회원번호'], []);

    // 전체라고 한 부분 컬럼 추가해야함
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '이름', value: 'name' },
        { label: '학교', value: 'university' },
        { label: '학과', value: 'major' },
        { label: '전화번호', value: 'phone' },
        { label: '회원번호', value: 'memberNumber' },
    ], []);

    useEffect(() => {
        userData();
    }, []);


    

    const formatPhoneNumber = (input) => {
        input = input.replace(/\D/g, ''); // 숫자만 남기기

        if (input.length > 3 && input.length <= 7) {
            return `${input.slice(0, 3)}-${input.slice(3)}`;
        } else if (input.length > 7) {
            return `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7, 11)}`;
        }
        return input;
    };

    const handleSearchInputChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;

        if (name === 'k_number') {
            formattedValue = formatPhoneNumber(value); // 전화번호 형식화
        }

        setUserSearchformValues((prevValues) => ({
            ...prevValues,
            [name]: formattedValue,
        }));
    };

    const handleSearchSubmit = (e) => {
        if (e.key === 'Enter' || e.type === 'click') {
            userData(); // 검색 로직 실행
        }
    };

    return (
        <>
            <AlertComponent />
            <LoadingComponent />
            <div className="components_wrap member_search_wrap">
                <span className='components_wrap_title'>회원 검색</span>


                <div className="user_search_wrap">
                    {/* <div className="search_info_txt">
                        <span>검색은 하루 5회만 가능합니다</span>
                    </div> */}
                    <div className="user_search_flex_box">
                        <div className="user_search_box">
                            <span className="user_search_box_title">이름</span>
                            <input
                                type="text"
                                name="k_name"
                                placeholder='이름을 입력해주세요.'
                                value={UserSearchformValues.k_name}
                                className="user_search_input"
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchSubmit} // 엔터 키 감지
                            />
                        </div>
                        {/* <div className="user_search_box">
                            <span className="user_search_box_title">회원번호</span>
                            <input
                                type="text"
                                name="k_code"
                                placeholder='회원번호를 입력해주세요.'
                                value={UserSearchformValues.k_code}
                                className="user_search_input"
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchSubmit} // 엔터 키 감지
                            />
                        </div>
                        <div className="user_search_box">
                            <span className="user_search_box_title">전화번호</span>
                            <input
                                type="text"
                                name="k_number"
                                placeholder="010-0000-0000"
                                value={UserSearchformValues.k_number}
                                className="user_search_input"
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchSubmit} // 엔터 키 감지
                            />
                        </div> */}
                        <div className="user_search_box">
                            <span className="user_search_box_title">학교</span>
                            <input
                                type="text"
                                name="k_university"
                                placeholder='학교를 입력해주세요.'
                                value={UserSearchformValues.k_university}
                                className="user_search_input"
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchSubmit} // 엔터 키 감지
                            />
                        </div>
                        <div className="user_search_box">
                            <span className="user_search_box_title">학과</span>
                            <input
                                type="text"
                                name="k_major"
                                placeholder='학과를 입력해주세요.'
                                value={UserSearchformValues.k_major}
                                className="user_search_input"
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchSubmit} // 엔터 키 감지
                            />
                        </div>
                        <div className="user_search_box">
                            <span className="user_search_box_title">직장</span>
                            <input
                                type="text"
                                name="k_job"
                                placeholder='직장을 입력해주세요.'
                                value={UserSearchformValues.k_job}
                                className="user_search_input"
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchSubmit} // 엔터 키 감지
                            />
                        </div>
                    </div>

                    <div className="search_btn_box">
                        <button className="search_btn" onClick={handleSearchSubmit}>검색</button>
                    </div>
                </div>
                

                {/* {user && user.length > 0 && ( */}
                    <TableList data={user} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"User"} />
                {/* )} */}
            </div>
        </>
    );
}

export default MembersSearch;